// A collection of enum, each of data-testid for different pages
export var AdminPageSidebarTestId;
(function (AdminPageSidebarTestId) {
    AdminPageSidebarTestId["AdminPageSideBar"] = "AdminPageSideBar";
    AdminPageSidebarTestId["AdminPageSideBarMenuItem"] = "AdminPageSideBarMenuItem";
})(AdminPageSidebarTestId || (AdminPageSidebarTestId = {}));
export var RedirectToContainer = 'RedirectToContainer';
export var BudgetPageTestId;
(function (BudgetPageTestId) {
    BudgetPageTestId["BudgetListNoBudgetText"] = "BudgetListNoBudgetText";
    BudgetPageTestId["BudgetListContainer"] = "BudgetListContainer";
    BudgetPageTestId["BudgetCell"] = "BudgetCell";
    BudgetPageTestId["BudgetDetail"] = "BudgetDetail";
    BudgetPageTestId["BudgetDetailTitle"] = "BudgetDetailTitle";
    BudgetPageTestId["BudgetRestrictionInfo"] = "BudgetRestrictionInfo";
    BudgetPageTestId["BudgetListBudgetTypeSummary"] = "BudgetListBudgetTypeSummary";
    BudgetPageTestId["BudgetListBudgetActiveDates"] = "BudgetListBudgetActiveDates";
    BudgetPageTestId["BudgetListBudgetType"] = "BudgetListBudgetType";
})(BudgetPageTestId || (BudgetPageTestId = {}));
export var PageNotFoundTestId;
(function (PageNotFoundTestId) {
    PageNotFoundTestId["PageNotFoundContainer"] = "PageNotFoundContainer";
})(PageNotFoundTestId || (PageNotFoundTestId = {}));
export var BootstrapContainerTestId;
(function (BootstrapContainerTestId) {
    BootstrapContainerTestId["LoadingSpinner"] = "BootstrapLoadingSpinner";
    BootstrapContainerTestId["RedirectLoadingSpinner"] = "BootstrapRedirectLoadingSpinner";
})(BootstrapContainerTestId || (BootstrapContainerTestId = {}));
